module.exports = __webpack_public_path__ + "static/img/tu14.9f4480d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tu14.png
// module id = GxYP
// module chunks = 10